import { createContext } from "react";

/**
 * The auth token context value type.
 */
export interface AuthTokenContextValue {
  /**
   * The current authentication token, or null if not authenticated.
   */
  readonly authToken: string | null;
}

/**
 * Context for providing authentication tokens to data source hooks.
 * This allows useRemoteTableDataSource and similar hooks to automatically
 * include Authorization headers without requiring explicit authToken props.
 */
export const AuthTokenContext = createContext<AuthTokenContextValue>({
  authToken: null,
});
